'use strict';

module.exports = {
    AGGREGATED_EVENT_BATCH_READY_FOR_PLATFORM_NOTIFICATIONS: 'aggregatedEventBatch.ready.for.platformNotifications'
};